import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getOrganizations } from 'app/entities/organization/organization.reducer';
import { createEntity, getEntity, reset, updateEntity } from './organization-configuration.reducer';

export const OrganizationConfigurationUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const organizations = useAppSelector(state => state.organization.entities);
  const organizationConfigurationEntity = useAppSelector(state => state.organizationConfiguration.entity);
  const loading = useAppSelector(state => state.organizationConfiguration.loading);
  const updating = useAppSelector(state => state.organizationConfiguration.updating);
  const updateSuccess = useAppSelector(state => state.organizationConfiguration.updateSuccess);

  const handleClose = () => {
    navigate(`/organization-configuration${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getOrganizations({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }

    const entity = {
      ...organizationConfigurationEntity,
      ...values,
      organization: organizations.find(it => it.id.toString() === values.organization?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...organizationConfigurationEntity,
          organization: organizationConfigurationEntity?.organization?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tycheApp.organizationConfiguration.home.createOrEditLabel" data-cy="OrganizationConfigurationCreateUpdateHeading">
            <Translate contentKey="tycheApp.organizationConfiguration.home.createOrEditLabel">
              Create or edit a OrganizationConfiguration
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="organization-configuration-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tycheApp.organizationConfiguration.apiKey')}
                id="organization-configuration-apiKey"
                name="apiKey"
                data-cy="apiKey"
                type="text"
              />
              <ValidatedField
                label={translate('tycheApp.organizationConfiguration.apiSecret')}
                id="organization-configuration-apiSecret"
                name="apiSecret"
                data-cy="apiSecret"
                type="text"
              />
              <ValidatedField
                label={translate('tycheApp.organizationConfiguration.callbackUrl')}
                id="organization-configuration-callbackUrl"
                name="callbackUrl"
                data-cy="callbackUrl"
                type="text"
              />
              <ValidatedField
                id="organization-configuration-organization"
                name="organization"
                data-cy="organization"
                label={translate('tycheApp.organizationConfiguration.organization')}
                type="select"
              >
                <option value="" key="0" />
                {organizations
                  ? organizations.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/organization-configuration" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default OrganizationConfigurationUpdate;
